/* eslint-disable import/no-cycle */
/* eslint-disable import/prefer-default-export */
import { set, setIsLoadingLoaded, clear } from './actions';
import { listPsqlCustomersV2 } from '../../../../../api/customers';

const thunkLoad = () => dispatch => {
	dispatch(clear());
	dispatch(
		setIsLoadingLoaded({
			isLoading: true,
			isLoaded: false
		})
	);
	listPsqlCustomersV2().then(data => {
		dispatch(set(data));
		dispatch(
			setIsLoadingLoaded({
				isLoading: false,
				isLoaded: true
			})
		);
	});
};

export { thunkLoad };
